var map = {
	"./en-US/cookie-policy.html": 614,
	"./nl-BE/cookie-policy.html": 617
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 333;



//////////////////
// WEBPACK FOOTER
// ./app/views/legal/partials cookie-policy\.html$
// module id = 333
// module chunks = 9